var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQuery } from '@apollo/client';
import { useACLCan } from 'app/domains/filesystem';
import { useActiveDocument } from 'shared/domains/documents';
import { AddDocumentAttachmentDocument } from './add.gql';
import { GetDocumentAttachmentsDocument } from './get.gql';
import { RemoveDocumentAttachmentDocument } from './remove.gql';
import { UpdateDocumentAttachmentDocument } from './update.gql';
export const useDocumentAttachments = () => {
    var _a, _b;
    const { id: documentId } = useActiveDocument();
    const { data, loading, error } = useQuery(GetDocumentAttachmentsDocument, {
        variables: { documentId },
    });
    const { accessLevel } = useACLCan({ userAcls: (_a = data === null || data === void 0 ? void 0 : data.document) === null || _a === void 0 ? void 0 : _a.acls, teamAcls: (_b = data === null || data === void 0 ? void 0 : data.document) === null || _b === void 0 ? void 0 : _b.teamAcls });
    const [addMutation, { loading: addingAttachment }] = useMutation(AddDocumentAttachmentDocument, {
        update: (cache, { data: addData }) => {
            if (addData === null || addData === void 0 ? void 0 : addData.addDocumentAttachment) {
                const { id } = addData.addDocumentAttachment;
                cache.modify({
                    id: cache.identify({ id: documentId, __typename: 'FileSystemDocument' }),
                    fields: {
                        attachments(existing = [], { toReference }) {
                            const newReference = toReference({ id, __typename: 'DocumentAttachment' }, true);
                            return [...existing, newReference];
                        },
                        attachmentsCount(currentCount = 0) {
                            return Math.max(currentCount + 1, 0);
                        },
                    },
                });
            }
        },
    });
    const [updateMutation, { loading: updatingAttachment }] = useMutation(UpdateDocumentAttachmentDocument);
    const [removeMutation, { loading: removingAttachment }] = useMutation(RemoveDocumentAttachmentDocument, {
        update(cache, { data: removeData }) {
            const { id, __typename } = (removeData === null || removeData === void 0 ? void 0 : removeData.removeDocumentAttachment) || {};
            cache.modify({
                id: cache.identify({ id, __typename }),
                fields(_, { DELETE }) {
                    return DELETE;
                },
            });
            cache.modify({
                id: cache.identify({ id: documentId, __typename: 'FileSystemDocument' }),
                fields: {
                    attachmentsCount(currentCount = 0) {
                        return Math.max(currentCount - 1, 0);
                    },
                },
            });
        },
    });
    const { documentAttachments, attachmentsCount } = (data === null || data === void 0 ? void 0 : data.document) || {};
    const count = attachmentsCount || 0;
    const attachments = documentAttachments || [];
    const isAttachmentLoading = addingAttachment || updatingAttachment || removingAttachment;
    const addAttachment = (input) => __awaiter(void 0, void 0, void 0, function* () { return addMutation({ variables: { input: Object.assign({ fileSystemDocumentId: documentId }, input) } }); });
    const updateAttachment = (input) => __awaiter(void 0, void 0, void 0, function* () {
        return updateMutation({
            variables: {
                attachmentId: input.attachmentId,
                input: {
                    name: input.name,
                },
            },
        });
    });
    const removeAttachment = (attachmentId) => __awaiter(void 0, void 0, void 0, function* () { return removeMutation({ variables: { attachmentId } }); });
    return {
        accessLevel,
        count,
        attachments,
        addingAttachment,
        isAttachmentLoading,
        error,
        loading,
        addAttachment,
        updateAttachment,
        removeAttachment,
    };
};
